import styled from 'styled-components';

export const HiddenAudio = styled.div`
  display: none;
`;
